<template>
    <modal
        max-width="600"
        v-model="show"
        @input="onInput"
        :has-padding="false"
        content-class="tracker-form modal-device"
    >
        <app-button
            v-if="!noActivator"
            class="btn btn-round btn-primary"
            slot="activator"
            :label="$t('message.trackers.message.create')"
            @click="openModal"
        >
        </app-button>

        <div class="tracker-form-body">
            <tracker-create-modal-nav-tabs
                data-padding="5px 50px 0 5px"
                v-model="tab"
                :data-tabs="tabs"
                class="nav-tabs"
                :is-edit="isEdit"
            />

            <tracker-create-modal-form
                v-if="show"
                ref="body"
                :item="item"
                v-model="form"
                v-show="isGeneralTab"
                @valid="save"
                @to-general-tab="tab = tabs[0]"
                @input="setFormData"
            />

            <tracker-create-modal-local-tree
                v-if="isLocalsTab"
                :locals="locals"
                :item="item"
                @select="addLocal"
                @deselect="removeLocal"
                v-model="form.localId"
            />

            <v-card-actions class="tracker-form-body-actions">
                <button
                    class="btn btn-extra-round btn-primary"
                    @click="$refs.body.$refs.form.submit()"
                >
                    {{ actionLabel }}
                </button>
            </v-card-actions>
        </div>
    </modal>
</template>

<script>
import TrackerCreateModalNavTabs from "./nav-tabs/TrackerCreateModalNavTabs.vue";
import TrackerCreateModalForm from "./form/TrackerCreateModalForm.vue";
import TrackerCreateModalLocalTree from "./local-tree/TrackerCreateModalLocalTree.vue";
import EventBus from "@packages/event-bus";
import Modal from "@/components/generic/Modal";
import AppButton from "@/components/generic/button/Button";

export default {
    components: {
        AppButton,
        TrackerCreateModalNavTabs,
        TrackerCreateModalForm,
        TrackerCreateModalLocalTree,
        Modal,
    },
    data() {
        return {
            show: false,
            form: {
                id: undefined,
                trackerIdentification: undefined,
                trackerTokenOrSecret: undefined,
                name: undefined,
                type: "FACEBOOK_PIXEL",
                isDefault: false,
                localId: [],
                ssidFilter: [],
                allSsidSelected: true,
            },
            tab: {
                value: "GENERAL",
                label: this.$t("message.generics.message.general"),
                disabled: this.isGeneralTabDisabled,
            },
            isLocalTabDisabled: true,
            isGeneralTabDisabled: false,
            locals: [],
            isOpenArray: [],
            trackerHasBeenCreated: false,
        };
    },

    props: {
        value: {
            type: Boolean,
            default: false,
        },
        item: {
            type: Object,
        },
        noActivator: {
            type: Boolean,
            default: false,
        },
        manualShow: {
            type: Boolean,
            default: false,
        },
    },

    watch: {
        show(val) {
            if (val) {
                if (this.isEdit) {
                    this.setInitialEditData();
                } else {
                    this.$refs.body.$refs.form.reset();
                    this.resetInitialData();
                }
            }
        },
        manualShow(showVal) {
            this.show = showVal;

            if (showVal && this.isEdit) {
                this.setInitialEditData();
            }
        },
    },

    computed: {
        isEdit() {
            return !!this.item;
        },
        actionLabel() {
            let label;
            if (this.isEdit) {
                label = this.$t("message.generics.message.save");
            } else {
                this.isGeneralTab
                    ? (label = this.$t("message.generics.message.advance"))
                    : (label = this.$t("message.generics.message.save"));
            }
            return label;
        },
        tabs() {
            return [
                {
                    value: "GENERAL",
                    label: this.$t("message.generics.message.general"),
                    disabled: this.isGeneralTabDisabled,
                },
                {
                    value: "LOCALS",
                    label: this.$t("message.generics.message.spots"),
                    disabled: this.isLocalTabDisabled,
                },
            ];
        },
        isGeneralTab() {
            if (!this.tab) return false;

            return this.tab.value === "GENERAL";
        },
        isLocalsTab() {
            if (!this.tab) return false;

            return this.tab.value === "LOCALS";
        },
        isFacebookType() {
            return this.form.type === "FACEBOOK_PIXEL";
        },
    },

    mounted() {
        this.tab = this.tabs[0];

        if (this.isEdit) {
            this.form = {
                id: this.item.id,
                trackerTokenOrSecret:
                    this.item.type === "FACEBOOK_PIXEL"
                        ? this.item.accessToken
                        : this.item.apiSecret,
                trackerIdentification:
                    this.item.type === "FACEBOOK_PIXEL"
                        ? this.item.pixelId
                        : this.item.measurementId,
                name: this.item.name,
                isDefault: this.item.isDefault,
                type: this.item.type,
                localId: this.item.localId,
                ssidFilter: this.item.ssidFilter,
                allSsidSelected: this.form.allSsidSelected,
            };
        }
    },

    methods: {
        resetInitialData() {
            this.tab = this.tabs[0];
            this.trackerHasBeenCreated = false;
            this.isLocalTabDisabled = true;
            this.form = {
                id: undefined,
                name: undefined,
                type: "FACEBOOK_PIXEL",
                trackerTokenOrSecret: undefined,
                trackerIdentification: undefined,
                isDefault: false,
                localId: [],
                ssidFilter: [],
                allSsidSelected: true,
            };
        },
        setInitialEditData() {
            this.isLocalTabDisabled = false;
            this.form = {
                id: this.item.id,
                name: this.item.name,
                trackerTokenOrSecret:
                    this.item.type === "FACEBOOK_PIXEL"
                        ? this.item.accessToken
                        : this.item.apiSecret,
                trackerIdentification:
                    this.item.type === "FACEBOOK_PIXEL"
                        ? this.item.pixelId
                        : this.item.measurementId,
                type: this.item.type,
                isDefault: this.item.isDefault,
                localId: this.item.localId,
                ssidFilter: this.item.ssidFilter,
                allSsidSelected: this.item.allSsidSelected,
            };
            this.$nextTick(() => (this.tab = this.tabs[0]));
        },
        emitBack() {
            this.$emit("back");
        },
        emitListModified() {
            EventBus.$emit("TRACKER_LIST_MODIFIED");
        },
        onInput(isModalOpen) {
            if (isModalOpen !== this.manualShow) {
                if (isModalOpen) {
                    this.openModal();
                } else {
                    this.closeModal();
                }
            }
        },
        openModal() {
            if (this.manualShow) {
                this.$emit("update:manualShow", true);
            } else {
                this.show = true;
            }
        },
        closeModal() {
            if (this.manualShow) {
                this.$emit("update:manualShow", false);
            } else {
                this.show = false;
            }
        },
        addLocal(node) {
            if (node.type === 1) {
                this.form.localId.push(node.objectId);
            }

            if (node.type === 0) {
                if (!node.children) {
                    return;
                } else {
                    node.children.map((childNode) => {
                        this.addLocal(childNode);
                    });
                }
            }
        },
        removeLocal(node) {
            if (node.type === 1) {
                const newLocals = this.form.localId.filter(
                    (localId) => localId !== node.objectId
                );
                this.form.localId = [...newLocals];
            }

            if (node.type === 0) {
                if (!node.children) {
                    return;
                } else {
                    node.children.map((childNode) => {
                        this.removeLocal(childNode);
                    });
                }
            }
        },

        removeLastChildren(locals) {
            for (const local of locals) {
                if (local.children.length > 0) {
                    this.removeLastChildren(local.children);
                } else {
                    local.children = undefined;
                }
            }

            return locals;
        },
        setIsOpenArray({ id, isOpen }) {
            if (isOpen) {
                const hasItem = this.isOpenArray.find((nodeId) => {
                    return id === nodeId;
                });

                if (!hasItem) {
                    this.isOpenArray.push(id);
                }
            } else {
                this.isOpenArray.filter((nodeId) => {
                    return nodeId === id;
                });
            }
        },
        validate() {
            this.$refs.body.validate();
        },
        validateType() {
            try {
                if (!this.form.type)
                    throw this.$t(
                        "message.errorMessages.message.selectTrackerType"
                    );
                return {
                    valid: true,
                };
            } catch (error) {
                return {
                    valid: false,
                    message: error,
                };
            }
        },
        async save() {
            const isEdit = this.isEdit;

            if (!isEdit) {
                if (this.isGeneralTab) {
                    const response = this.validateType();
                    if (!response.valid) {
                        return EventBus.$emit("show-message", {
                            type: "ERROR",
                            message: response.message,
                        });
                    }
                    if (!this.trackerHasBeenCreated) {
                        const tracker = await this.$api.core.trackers.save({
                            name: this.form.name,
                            type: this.form.type,
                            isDefault: this.form.isDefault,
                            trackerIdentification:
                                this.form.trackerIdentification,
                            trackerTokenOrSecret:
                                this.form.trackerTokenOrSecret,
                            localId: this.form.localId,
                            ssidFilter: this.form.ssidFilter,
                            allSsidSelected: this.form.allSsidSelected,
                        });
                        this.form.id = tracker.id;
                        this.isLocalTabDisabled = false;
                        this.trackerHasBeenCreated = true;
                    } else {
                        await this.$api.core.trackers.edit({
                            id: this.form.id,
                            name: this.form.name,
                            type: this.form.type,
                            isDefault: this.form.isDefault,
                            trackerIdentification:
                                this.form.trackerIdentification,
                            trackerTokenOrSecret:
                                this.form.trackerTokenOrSecret,
                            localId: this.form.localId,
                            ssidFilter: this.form.ssidFilter,
                            allSsidSelected: this.form.allSsidSelected,
                        });
                    }

                    this.tab = this.tabs[1];

                    this.locals = await this.$api.core.trackers.getLocalTree({
                        id: this.form.id,
                    });
                    this.removeLastChildren(this.locals);
                } else {
                    await this.$api.core.trackers.edit({
                        id: this.form.id,
                        name: this.form.name,
                        type: this.form.type,
                        isDefault: this.form.isDefault,
                        trackerIdentification: this.form.trackerIdentification,
                        trackerTokenOrSecret: this.form.trackerTokenOrSecret,
                        localId: this.form.localId,
                        ssidFilter: this.form.ssidFilter,
                        allSsidSelected: this.form.allSsidSelected,
                    });

                    this.resetInitialData();

                    EventBus.$emit("show-message", {
                        type: "SUCCESS",
                        message: this.$t(
                            "message.successMessages.message.trackerCreated"
                        ),
                        timeout: 2000,
                    });

                    this.onInput();
                    this.resetFormValidation();
                    this.emitListModified();
                }
            } else {
                const response = this.validateType();
                if (!response.valid) {
                    return EventBus.$emit("show-message", {
                        type: "ERROR",
                        message: response.message,
                    });
                }
                await this.$api.core.trackers.edit({
                    id: this.form.id,
                    name: this.form.name,
                    type: this.form.type,
                    isDefault: this.form.isDefault,
                    trackerIdentification: this.form.trackerIdentification,
                    trackerTokenOrSecret: this.form.trackerTokenOrSecret,
                    localId: this.form.localId,
                    ssidFilter: this.form.ssidFilter,
                    allSsidSelected: this.form.allSsidSelected,
                });

                EventBus.$emit("show-message", {
                    type: "SUCCESS",
                    message: this.$t(
                        "message.successMessages.message.trackerEdited"
                    ),
                    timeout: 2000,
                });

                this.onInput();
                this.emitListModified();
            }
        },
        setFormData(value) {
            (this.form.trackerIdentification = value.trackerIdentification),
                (this.form.trackerTokenOrSecret = value.trackerTokenOrSecret),
                (this.form.name = value.name);
            this.form.type = value.type;
            this.form.isDefault = value.isDefault;
        },
        resetFormValidation() {
            this.$refs.body.$refs.form.reset();
        },
    },
};
</script>

<style lang="scss" scoped>
.tracker-form {
    .tracker-form-body {
        padding: 5px 20px 10px;

        .nav-tabs {
            margin-bottom: 20px;
        }

        .tracker-form-body-inputs {
            width: 60%;
            margin: 0 auto 3px;
        }

        .tracker-form-body-actions {
            display: flex;
            justify-content: center;
        }
    }
}
</style>
